<template>
  <section>
    <!-- search -->
    <form @submit.prevent="loadData">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <div class="cell">
              <select
                class="selectBox"
                style="display:inline-block;width:100px;"
                v-model="formData.range"
              >
                <option value="DAILY">일간</option>
                <option value="WEEKLY">주간</option>
                <option value="MONTHLY">월간</option>
                <option value="YEARLY">년간</option>
              </select>

              <!-- 일간 -->
              <DatePicker
                v-if="formData.range === 'DAILY'"
                :value="$utils.calcDate(null, '-1d')"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <WeekPicker
                v-if="formData.range === 'WEEKLY'"
                class="blank"
                width="300px"
                ref="picker"
                :value="$utils.calcDate(new Date(), '-1w')"
                :maxDate="new Date()"
              />
              <MonthPicker
                v-if="formData.range === 'MONTHLY'"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <YearPicker
                v-if="formData.range === 'YEARLY'"
                class="blank"
                ref="picker"
                minDate="2017"
                :maxDate="new Date()"
              />
            </div>
            <span class="label">지역</span>
            <div class="cell">
              <GroupSelector permissionCode="statistic" :useGroup="false" ref="groupSelector" />
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->

    <div v-if="res" ref="tableWrap">
      <h4 class="section_title">
        <span class="ico"></span>
        콘텐츠별 조회수 순위 10
      </h4>
      <SearchTable :itemArray="searchItems" />

      <h4 class="section_title">
        <span class="ico"></span>
        검색 키워드 순위 10
      </h4>
      <KeywordTable :itemArray="keywordItems" />
    </div>

    <div class="section_button none_paginate">
      <ExcelDownloadButton
        v-if="res"
        :filename="$utils.excelName('건강백세', '콘텐츠통계')"
        :tablesContainer="$refs.tableWrap"
      />
      <HelpButton contentId="HELP_05" />
    </div>
  </section>
</template>

<script>
import { times } from "lodash";
import SearchTable from "./Table.search";
import KeywordTable from "./Table.keyword";

export default {
  components: {
    SearchTable,
    KeywordTable
  },
  data() {
    return {
      res: null,
      searchItems: null,
      keywordItems: null,
      formData: {
        range: "WEEKLY",
        state: "",
        city: ""
      }
    };
  },
  methods: {
    loadData() {
      const options = this.requestOptions();
      this.$axios
        .get("/admin/happy/stats/v2/health/content", options)
        .then(({ data }) => {
          // 순위 테이블은 총 10개를 출력한다.
          const searchMaxNum = Math.max(
            data.healthTokTokList.length,
            data.mindGymList.length,
            data.goodThinkingList.length
          );
          const searchItems = times(searchMaxNum, i => ({
            rank: i + 1,
            health: data.healthTokTokList[i] || null,
            mind: data.mindGymList[i] || null,
            goodThinking: data.goodThinkingList[i] || null
          }));

          const keywordMaxNum = Math.max(
            data.healthSuccessKeywordList.length,
            data.healthFailKeywordList.length,
            data.mindGymSuccessKeywordList.length,
            data.mindGymFailKeywordList.length,
          );
          const keywordItems = times(keywordMaxNum, i => ({
            rank: i + 1,
            healthSuccess: data.healthSuccessKeywordList[i] || null,
            healthFail: data.healthFailKeywordList[i] || null,
            mindGymSuccess: data.mindGymSuccessKeywordList[i] || null,
            mindGymFail: data.mindGymFailKeywordList[i] || null
          }));

          this.res = data;
          this.searchItems = searchItems;
          this.keywordItems = keywordItems;
        });
    },
    requestOptions() {
      const group = this.$refs.groupSelector.getData();
      const startDate = this.$refs.picker.getDate();

      return {
        params: _.merge(this.formData, {
          searchDate: this.$utils.dateText(startDate),
          orgCode: group.orgId,
          state: group.stateId,
          city: group.cityId
        })
      };
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
